
import { Vue } from "vue-class-component";
import { ForwardBookingCommissionController } from "@/app/ui/controllers/ForwardBookingCommissionController";

export default class ForwardBookingCommissionDetailSectionGeneralConfig extends Vue {
  get detailData() {
    return ForwardBookingCommissionController.forwardBookingCommissionDetail;
  }
}
